import React from 'react';

export function ProblemSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-8">
            The frustrating reality
          </h2>
          
          <div className="max-w-4xl mx-auto">
            <p className="text-xl sm:text-2xl text-gray-700 leading-relaxed">
              Built something on <span className="font-semibold text-purple-600">Lovable</span>, <span className="font-semibold text-purple-600">Cursor</span>, or <span className="font-semibold text-purple-600">v0</span>? 
              You're not alone in wondering... <span className="italic font-medium">now what?</span>
            </p>
          </div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">Zero Users</h3>
            <p className="text-gray-600 text-center leading-relaxed">
              Most AI-built apps get zero users because they're missing the growth essentials that actually matter.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">What's Missing?</h3>
            <p className="text-gray-600 text-center leading-relaxed">
              No analytics, no user tracking, no marketing pixels, no email capture. The code works, but growth doesn't.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">Need Direction</h3>
            <p className="text-gray-600 text-center leading-relaxed">
              You know your app needs growth features, but which ones? And how do you implement them correctly?
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}